import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "admin/AuthContext";
import logo from "../../assets/images/logo.png";

export default function AdminLogin() {
  const { login, isAuthenticated, error, usingDemoAuth } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isAuthenticated) navigate("/admin", { replace: true });
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const ok = await login(email, password);
    setIsSubmitting(false);
    if (ok) navigate("/admin", { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src={logo} alt="" className="mb-3 h-14 w-14 rounded-xl" />
          <h1 className="font-display text-2xl font-bold text-maroon-800">VR Food Products</h1>
          <p className="mt-1 text-sm text-slate-500">Admin Dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          {!usingDemoAuth && (
            <div className="mb-4">
              <label className="block" htmlFor="email">
                <span className="mb-1.5 block text-sm font-medium text-slate-700">Email</span>
                <input
                  id="email"
                  type="email"
                  autoComplete="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-maroon-400 focus:outline-none focus:ring-2 focus:ring-maroon-100"
                />
              </label>
            </div>
          )}

          <div className="mb-2">
            <label className="block" htmlFor="password">
              <span className="mb-1.5 block text-sm font-medium text-slate-700">Password</span>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-maroon-400 focus:outline-none focus:ring-2 focus:ring-maroon-100"
              />
            </label>
          </div>

          {usingDemoAuth && (
            <p className="mb-4 text-xs text-slate-400">
              Demo mode — default password is <code className="rounded bg-slate-100 px-1 py-0.5">vrfood-admin</code>
              .
            </p>
          )}

          {error && (
            <p role="alert" className="mb-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="mt-2 w-full rounded-lg bg-maroon-700 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-maroon-800 disabled:opacity-60"
          >
            {isSubmitting ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
